
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.4.1
 * Query Engine version: 2f302df92bd8945e20ad4595a73def5b96afa54f
 */
Prisma.prismaVersion = {
  client: "5.4.1",
  engine: "2f302df92bd8945e20ad4595a73def5b96afa54f"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.PromotionsScalarFieldEnum = {
  PromotionID: 'PromotionID',
  UserID: 'UserID',
  Code: 'Code',
  Description: 'Description',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.PackagesScalarFieldEnum = {
  PackageID: 'PackageID',
  Name: 'Name',
  Tag: 'Tag',
  Price: 'Price',
  EffectiveMonthlyPrice: 'EffectiveMonthlyPrice',
  Description: 'Description',
  VideoBundleID: 'VideoBundleID',
  PromotionID: 'PromotionID',
  ImageUrl: 'ImageUrl',
  CreditsToAward: 'CreditsToAward',
  CreditExpiryInterval: 'CreditExpiryInterval',
  CreditExpiryUnit: 'CreditExpiryUnit',
  RentalExpiryInterval: 'RentalExpiryInterval',
  RentalExpiryUnit: 'RentalExpiryUnit',
  RecurInterval: 'RecurInterval',
  RecurUnit: 'RecurUnit',
  Hidden: 'Hidden',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.PurchasesScalarFieldEnum = {
  PurchaseID: 'PurchaseID',
  PackageID: 'PackageID',
  AdditionalPackageID: 'AdditionalPackageID',
  UserID: 'UserID',
  UserPaymentID: 'UserPaymentID',
  SubscriptionID: 'SubscriptionID',
  SubscriptionStartDate: 'SubscriptionStartDate',
  VideoID: 'VideoID',
  StarID: 'StarID',
  Source: 'Source',
  SourceID: 'SourceID',
  State: 'State',
  StateMeta: 'StateMeta',
  Assignable: 'Assignable',
  AssignableContact: 'AssignableContact',
  AssignableNote: 'AssignableNote',
  AssignableCode: 'AssignableCode',
  AssignedTo: 'AssignedTo',
  CreatedAt: 'CreatedAt',
  MigratedSubscriptionID: 'MigratedSubscriptionID'
};

exports.Prisma.TransactionsScalarFieldEnum = {
  TransactionID: 'TransactionID',
  PackageID: 'PackageID',
  AdditionalPackageID: 'AdditionalPackageID',
  FromPackageID: 'FromPackageID',
  PurchaseID: 'PurchaseID',
  AuthNetTransID: 'AuthNetTransID',
  UserID: 'UserID',
  UserPaymentID: 'UserPaymentID',
  Amount: 'Amount',
  CreditsToAward: 'CreditsToAward',
  Assignable: 'Assignable',
  AssignedTo: 'AssignedTo',
  Renewal: 'Renewal',
  State: 'State',
  DeclineReason: 'DeclineReason',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.CreditsScalarFieldEnum = {
  CreditID: 'CreditID',
  PackageID: 'PackageID',
  PurchaseID: 'PurchaseID',
  TransactionID: 'TransactionID',
  UserID: 'UserID',
  Assignable: 'Assignable',
  AssignableContact: 'AssignableContact',
  AssignableNote: 'AssignableNote',
  AssignableCode: 'AssignableCode',
  AssignedTo: 'AssignedTo',
  State: 'State',
  StateMeta: 'StateMeta',
  ExpiresAt: 'ExpiresAt',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.RentalsScalarFieldEnum = {
  RentID: 'RentID',
  CreditID: 'CreditID',
  PackageID: 'PackageID',
  PurchaseID: 'PurchaseID',
  TransactionID: 'TransactionID',
  VideoID: 'VideoID',
  Source: 'Source',
  SourceID: 'SourceID',
  UserID: 'UserID',
  Earned: 'Earned',
  StarID: 'StarID',
  ExpiresAt: 'ExpiresAt',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.AuditLogsScalarFieldEnum = {
  AuditLogID: 'AuditLogID',
  PurchaseID: 'PurchaseID',
  TransactionID: 'TransactionID',
  CreditID: 'CreditID',
  UserID: 'UserID',
  Action: 'Action',
  State: 'State',
  Message: 'Message',
  Details: 'Details',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.AuthorizeEventLogsScalarFieldEnum = {
  EventID: 'EventID',
  UUID: 'UUID',
  EventType: 'EventType',
  EntityType: 'EntityType',
  EntityID: 'EntityID',
  Payload: 'Payload',
  HashMatch: 'HashMatch',
  ProvidedHash: 'ProvidedHash',
  CalculatedHash: 'CalculatedHash',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.JobsScalarFieldEnum = {
  JobID: 'JobID',
  Type: 'Type',
  ObjectID: 'ObjectID',
  Description: 'Description',
  Args: 'Args',
  Status: 'Status',
  Attempts: 'Attempts',
  Message: 'Message',
  Details: 'Details',
  RunAt: 'RunAt',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.VideoBundleScalarFieldEnum = {
  VideoBundleID: 'VideoBundleID',
  Name: 'Name',
  Tag: 'Tag',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoBundleVideosScalarFieldEnum = {
  VideoID: 'VideoID',
  VideoBundleID: 'VideoBundleID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.BundleScalarFieldEnum = {
  BundleID: 'BundleID',
  VideoBundleID: 'VideoBundleID',
  Name: 'Name',
  Amount: 'Amount',
  Point: 'Point',
  ExpiryDay: 'ExpiryDay',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  Status: 'Status',
  Deleted: 'Deleted'
};

exports.Prisma.CategoryScalarFieldEnum = {
  CatID: 'CatID',
  Name: 'Name',
  Slug: 'Slug',
  Description: 'Description',
  ParentID: 'ParentID',
  Status: 'Status',
  Deleted: 'Deleted',
  OrderNumber: 'OrderNumber',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.CuratedCollectionScalarFieldEnum = {
  CuratedID: 'CuratedID',
  Title: 'Title',
  Description: 'Description',
  Status: 'Status',
  Deleted: 'Deleted',
  OrderNumber: 'OrderNumber',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.UserTagPreferencesScalarFieldEnum = {
  UserTagPreferenceID: 'UserTagPreferenceID',
  UserID: 'UserID',
  TagID: 'TagID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.LandingVideoScalarFieldEnum = {
  LandingID: 'LandingID',
  VideoID: 'VideoID',
  Sort: 'Sort',
  Type: 'Type',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.MarqueeGroupTagScalarFieldEnum = {
  MarqueeGroupTagID: 'MarqueeGroupTagID',
  MarqueeGroupID: 'MarqueeGroupID',
  MarqueeTagID: 'MarqueeTagID',
  Sort: 'Sort'
};

exports.Prisma.MarqueeGroupsScalarFieldEnum = {
  MarqueeGroupID: 'MarqueeGroupID',
  Name: 'Name',
  Sort: 'Sort'
};

exports.Prisma.MarqueeTagsScalarFieldEnum = {
  MarqueeTagID: 'MarqueeTagID',
  Name: 'Name',
  Slug: 'Slug',
  Status: 'Status',
  Deleted: 'Deleted',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  PublishedAt: 'PublishedAt'
};

exports.Prisma.NewsletterEmailScalarFieldEnum = {
  NewsletterID: 'NewsletterID',
  Email: 'Email',
  Status: 'Status',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.NotificationScalarFieldEnum = {
  ID: 'ID',
  ViewerID: 'ViewerID',
  ViewerUN: 'ViewerUN',
  ViewerDN: 'ViewerDN',
  ViewerAvatar: 'ViewerAvatar',
  Type: 'Type',
  VideoID: 'VideoID',
  VideoTitle: 'VideoTitle',
  StarID: 'StarID',
  ActionID: 'ActionID',
  Status: 'Status',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  Deleted: 'Deleted'
};

exports.Prisma.UserRecentlyViewedVideosScalarFieldEnum = {
  UserID: 'UserID',
  VideoID: 'VideoID',
  ViewedAt: 'ViewedAt'
};

exports.Prisma.OrdersScalarFieldEnum = {
  OrderID: 'OrderID',
  OrderCode: 'OrderCode',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  OwnerID: 'OwnerID',
  IPAddress: 'IPAddress',
  TransID: 'TransID',
  UserPaymentID: 'UserPaymentID',
  Amount: 'Amount',
  Currency: 'Currency',
  CreatedAt: 'CreatedAt',
  Status: 'Status',
  PaymentType: 'PaymentType',
  Deleted: 'Deleted'
};

exports.Prisma.ReferFriendScalarFieldEnum = {
  ID: 'ID',
  ReceiverID: 'ReceiverID',
  ReceiverCognitoID: 'ReceiverCognitoID',
  ReceiverUN: 'ReceiverUN',
  ReceiverEmail: 'ReceiverEmail',
  RegisterID: 'RegisterID',
  RegisterCognitoID: 'RegisterCognitoID',
  RegisterUN: 'RegisterUN',
  RegisterEmail: 'RegisterEmail',
  Status: 'Status',
  CreatedAt: 'CreatedAt',
  ActivedAt: 'ActivedAt'
};

exports.Prisma.ReportBugsScalarFieldEnum = {
  BugID: 'BugID',
  Email: 'Email',
  Title: 'Title',
  Content: 'Content',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.TagsScalarFieldEnum = {
  TagID: 'TagID',
  Name: 'Name',
  UserAttributeTagTypeID: 'UserAttributeTagTypeID',
  Slug: 'Slug',
  Description: 'Description',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.UserBundlePointScalarFieldEnum = {
  BundlePointID: 'BundlePointID',
  Point: 'Point',
  OrderID: 'OrderID',
  Status: 'Status',
  StartDate: 'StartDate',
  ExpiredDate: 'ExpiredDate',
  CreatedAt: 'CreatedAt',
  BundleID: 'BundleID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  Manual: 'Manual',
  Deleted: 'Deleted'
};

exports.Prisma.UserPaymentScalarFieldEnum = {
  UserPaymentID: 'UserPaymentID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  CustomerProfileId: 'CustomerProfileId',
  PaymentProfileId: 'PaymentProfileId',
  CardHolder: 'CardHolder',
  CardNumber: 'CardNumber',
  CardExpDate: 'CardExpDate',
  CardType: 'CardType',
  CardStatus: 'CardStatus',
  FirstName: 'FirstName',
  LastName: 'LastName',
  Email: 'Email',
  Address: 'Address',
  City: 'City',
  Country: 'Country',
  State: 'State',
  Zip: 'Zip',
  Phone: 'Phone',
  DeclineCode: 'DeclineCode',
  DeclinedAt: 'DeclinedAt',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  Deleted: 'Deleted'
};

exports.Prisma.UserRentScalarFieldEnum = {
  RentID: 'RentID',
  OwnerID: 'OwnerID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  VideoID: 'VideoID',
  StarID: 'StarID',
  PackageID: 'PackageID',
  Earned: 'Earned',
  CreatedAt: 'CreatedAt',
  RentType: 'RentType',
  Deleted: 'Deleted'
};

exports.Prisma.UserSocialPostsScalarFieldEnum = {
  SocialPostID: 'SocialPostID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  Title: 'Title',
  Comment: 'Comment',
  File: 'File',
  Status: 'Status',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  Deleted: 'Deleted',
  PublishedAt: 'PublishedAt'
};

exports.Prisma.UserSubscriptionScalarFieldEnum = {
  UserSubscriptionID: 'UserSubscriptionID',
  SubscriptionID: 'SubscriptionID',
  UserSubscriptionParentID: 'UserSubscriptionParentID',
  Name: 'Name',
  Type: 'Type',
  Package: 'Package',
  Amount: 'Amount',
  IntervalLength: 'IntervalLength',
  IntervalUnit: 'IntervalUnit',
  StartDate: 'StartDate',
  TotalOccurrences: 'TotalOccurrences',
  GifteeUserID: 'GifteeUserID',
  GifteeCognitoUserID: 'GifteeCognitoUserID',
  GifterName: 'GifterName',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  UserPaymentID: 'UserPaymentID',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  Status: 'Status',
  Deleted: 'Deleted'
};

exports.Prisma.UserSubscriptionPointScalarFieldEnum = {
  SubscriptionPointID: 'SubscriptionPointID',
  Point: 'Point',
  OrderID: 'OrderID',
  Status: 'Status',
  StartDate: 'StartDate',
  ExpiredDate: 'ExpiredDate',
  CreatedAt: 'CreatedAt',
  UserSubscriptionID: 'UserSubscriptionID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  Manual: 'Manual',
  Deleted: 'Deleted'
};

exports.Prisma.UsersScalarFieldEnum = {
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  CognitoUserName: 'CognitoUserName',
  CustomerProfileId: 'CustomerProfileId',
  Email: 'Email',
  UserName: 'UserName',
  WordpressPassword: 'WordpressPassword',
  PasswordHash: 'PasswordHash',
  PasswordResetToken: 'PasswordResetToken',
  DisplayName: 'DisplayName',
  ReferredBy: 'ReferredBy',
  ReferralResult: 'ReferralResult',
  ReferralCode: 'ReferralCode',
  Pronouns: 'Pronouns',
  SocialLink: 'SocialLink',
  CaptivatedBy: 'CaptivatedBy',
  NeedToLive: 'NeedToLive',
  GratefulFor: 'GratefulFor',
  Avatar: 'Avatar',
  Private: 'Private',
  WelcomeFlow: 'WelcomeFlow',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  Status: 'Status',
  Deleted: 'Deleted',
  Role: 'Role',
  FlaggedAsBot: 'FlaggedAsBot',
  VerifyLink: 'VerifyLink',
  LastLoginAt: 'LastLoginAt',
  LastNotificationSeen: 'LastNotificationSeen',
  SendgridRecipientID: 'SendgridRecipientID',
  ReengagementCreditUsed: 'ReengagementCreditUsed',
  ThreeShadesCreditUsed: 'ThreeShadesCreditUsed',
  RedirectToAfterActivation: 'RedirectToAfterActivation'
};

exports.Prisma.NotificationsScalarFieldEnum = {
  ID: 'ID',
  UserID: 'UserID',
  BroadcasterID: 'BroadcasterID',
  VideoID: 'VideoID',
  SocialPostID: 'SocialPostID',
  CommentID: 'CommentID',
  Title: 'Title',
  Description: 'Description',
  ActionLink: 'ActionLink',
  ActionText: 'ActionText',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.UsersInvalidScalarFieldEnum = {
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  Email: 'Email',
  UserName: 'UserName',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.UsersStarsScalarFieldEnum = {
  StarID: 'StarID',
  UserID: 'UserID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoBookmarkScalarFieldEnum = {
  BookmarkID: 'BookmarkID',
  VideoID: 'VideoID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoCategoryScalarFieldEnum = {
  VideoCatID: 'VideoCatID',
  VideoID: 'VideoID',
  CatID: 'CatID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoCommentScalarFieldEnum = {
  CommentID: 'CommentID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  VideoID: 'VideoID',
  ForumThreadID: 'ForumThreadID',
  ParentCommentID: 'ParentCommentID',
  Content: 'Content',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  Status: 'Status',
  Deleted: 'Deleted',
  PublishedAt: 'PublishedAt',
  PurchaseID: 'PurchaseID',
  Earned: 'Earned',
  StarID: 'StarID',
  IsAnonymous: 'IsAnonymous'
};

exports.Prisma.VideoCuratedScalarFieldEnum = {
  VideoCuratedID: 'VideoCuratedID',
  VideoID: 'VideoID',
  CuratedID: 'CuratedID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoLikeScalarFieldEnum = {
  LikeID: 'LikeID',
  VideoID: 'VideoID',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoMarqueeTagsScalarFieldEnum = {
  VideoMarqueeTagID: 'VideoMarqueeTagID',
  VideoID: 'VideoID',
  MarqueeTagID: 'MarqueeTagID',
  Sort: 'Sort'
};

exports.Prisma.VideoParticipantsScalarFieldEnum = {
  ParticipantID: 'ParticipantID',
  FirstName: 'FirstName',
  LastName: 'LastName',
  NickName: 'NickName',
  Email: 'Email',
  Birthday: 'Birthday',
  Country: 'Country',
  IDImageOne: 'IDImageOne',
  IDImageTwo: 'IDImageTwo',
  Deleted: 'Deleted',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.VideoTagsScalarFieldEnum = {
  VideoTagID: 'VideoTagID',
  VideoID: 'VideoID',
  TagID: 'TagID',
  Sort: 'Sort'
};

exports.Prisma.MetaTagsScalarFieldEnum = {
  MetaTagID: 'MetaTagID',
  Name: 'Name',
  Slug: 'Slug',
  Description: 'Description',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.VideoMetaTagsScalarFieldEnum = {
  VideoMetaTagID: 'VideoMetaTagID',
  VideoID: 'VideoID',
  MetaTagID: 'MetaTagID',
  Sort: 'Sort'
};

exports.Prisma.VideosScalarFieldEnum = {
  VideoID: 'VideoID',
  FirstName: 'FirstName',
  LastName: 'LastName',
  NickName: 'NickName',
  Birthday: 'Birthday',
  Country: 'Country',
  IDImageOne: 'IDImageOne',
  IDImageTwo: 'IDImageTwo',
  Participants: 'Participants',
  VideoTitle: 'VideoTitle',
  Slug: 'Slug',
  Slug0: 'Slug0',
  VideoDescription: 'VideoDescription',
  Content: 'Content',
  VideoFilm: 'VideoFilm',
  VideoTags: 'VideoTags',
  VideoIntro: 'VideoIntro',
  VideoIntroFlipped: 'VideoIntroFlipped',
  VideoIntroCaptions: 'VideoIntroCaptions',
  VideoReal: 'VideoReal',
  VideoRealFlipped: 'VideoRealFlipped',
  VideoRealCaptions: 'VideoRealCaptions',
  VideoDuration: 'VideoDuration',
  LandingVideo: 'LandingVideo',
  LandingVideoType: 'LandingVideoType',
  Stills: 'Stills',
  BlurredStill: 'BlurredStill',
  BlurPercentage: 'BlurPercentage',
  VideoType: 'VideoType',
  Status: 'Status',
  Visibility: 'Visibility',
  Deleted: 'Deleted',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',
  PublishedAt: 'PublishedAt',
  UserID: 'UserID',
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.ContentPagesScalarFieldEnum = {
  PageID: 'PageID',
  PageName: 'PageName',
  Content: 'Content',
  HtmlContent: 'HtmlContent',
  Version: 'Version',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.RecaptchasScalarFieldEnum = {
  RecaptchaID: 'RecaptchaID',
  UserID: 'UserID',
  Success: 'Success',
  Hostname: 'Hostname',
  Score: 'Score',
  Action: 'Action',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoCleanScalarFieldEnum = {
  VideoCleanID: 'VideoCleanID',
  LastPublishedAt: 'LastPublishedAt',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.AuthorizeEventProcessedScalarFieldEnum = {
  AuthorizeEventProcessedID: 'AuthorizeEventProcessedID',
  LastAuthorizeEventID: 'LastAuthorizeEventID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.UserEventsScalarFieldEnum = {
  EventID: 'EventID',
  UserID: 'UserID',
  Name: 'Name',
  Details: 'Details',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.UserEventProcessedScalarFieldEnum = {
  UserEventProcessedID: 'UserEventProcessedID',
  LastUserEventID: 'LastUserEventID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.UserEmailsScalarFieldEnum = {
  EmailID: 'EmailID',
  UserID: 'UserID',
  Type: 'Type',
  CreatedAt: 'CreatedAt',
  SendAt: 'SendAt',
  Details: 'Details',
  Error: 'Error',
  Sent: 'Sent',
  SentAt: 'SentAt'
};

exports.Prisma.SearchesScalarFieldEnum = {
  SearchID: 'SearchID',
  UserID: 'UserID',
  Term: 'Term',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoViewSourcesScalarFieldEnum = {
  ViewID: 'ViewID',
  Source: 'Source',
  SourceID: 'SourceID',
  VideoID: 'VideoID',
  UserID: 'UserID',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.CohortSummaryScalarFieldEnum = {
  Cohort: 'Cohort',
  Type: 'Type',
  Total: 'Total',
  Timeframe: 'Timeframe',
  Date: 'Date',
  Count: 'Count'
};

exports.Prisma.RentalSummaryScalarFieldEnum = {
  Date: 'Date',
  Type: 'Type',
  Range: 'Range',
  Count: 'Count'
};

exports.Prisma.UserAttributeTagTypeScalarFieldEnum = {
  UserAttributeTagTypeID: 'UserAttributeTagTypeID',
  Name: 'Name',
  Description: 'Description',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.UserAttributeTagsScalarFieldEnum = {
  UserAttributeTagID: 'UserAttributeTagID',
  UserID: 'UserID',
  TagID: 'TagID',
  AssignedBy: 'AssignedBy',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.VideoPlaybacksScalarFieldEnum = {
  PlaybackID: 'PlaybackID',
  VideoID: 'VideoID',
  VideoType: 'VideoType',
  UserID: 'UserID',
  UserType: 'UserType',
  EventType: 'EventType',
  Version: 'Version',
  Seconds: 'Seconds',
  SecondsVector: 'SecondsVector',
  VideoDuration: 'VideoDuration',
  CreatedAt: 'CreatedAt'
};

exports.Prisma.ForumThreadsScalarFieldEnum = {
  ForumThreadID: 'ForumThreadID',
  UserID: 'UserID',
  Title: 'Title',
  Content: 'Content',
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.PromotionsOrderByRelevanceFieldEnum = {
  Code: 'Code',
  Description: 'Description'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.PackagesOrderByRelevanceFieldEnum = {
  Name: 'Name',
  Tag: 'Tag',
  Description: 'Description',
  ImageUrl: 'ImageUrl',
  CreditExpiryInterval: 'CreditExpiryInterval',
  RentalExpiryInterval: 'RentalExpiryInterval',
  RecurInterval: 'RecurInterval'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.PurchasesOrderByRelevanceFieldEnum = {
  SubscriptionID: 'SubscriptionID',
  Source: 'Source',
  State: 'State',
  AssignableContact: 'AssignableContact',
  AssignableNote: 'AssignableNote',
  AssignableCode: 'AssignableCode'
};

exports.Prisma.TransactionsOrderByRelevanceFieldEnum = {
  AuthNetTransID: 'AuthNetTransID',
  State: 'State'
};

exports.Prisma.CreditsOrderByRelevanceFieldEnum = {
  AssignableContact: 'AssignableContact',
  AssignableNote: 'AssignableNote',
  AssignableCode: 'AssignableCode',
  State: 'State'
};

exports.Prisma.RentalsOrderByRelevanceFieldEnum = {
  Source: 'Source'
};

exports.Prisma.AuditLogsOrderByRelevanceFieldEnum = {
  Action: 'Action',
  State: 'State',
  Message: 'Message',
  Details: 'Details'
};

exports.Prisma.AuthorizeEventLogsOrderByRelevanceFieldEnum = {
  UUID: 'UUID',
  EventType: 'EventType',
  EntityType: 'EntityType',
  EntityID: 'EntityID',
  ProvidedHash: 'ProvidedHash',
  CalculatedHash: 'CalculatedHash'
};

exports.Prisma.JobsOrderByRelevanceFieldEnum = {
  Type: 'Type',
  Description: 'Description',
  Status: 'Status',
  Message: 'Message'
};

exports.Prisma.VideoBundleOrderByRelevanceFieldEnum = {
  Name: 'Name',
  Tag: 'Tag'
};

exports.Prisma.BundleOrderByRelevanceFieldEnum = {
  Name: 'Name'
};

exports.Prisma.CategoryOrderByRelevanceFieldEnum = {
  Name: 'Name',
  Slug: 'Slug',
  Description: 'Description'
};

exports.Prisma.CuratedCollectionOrderByRelevanceFieldEnum = {
  Title: 'Title',
  Description: 'Description'
};

exports.Prisma.LandingVideoOrderByRelevanceFieldEnum = {
  Type: 'Type'
};

exports.Prisma.MarqueeGroupsOrderByRelevanceFieldEnum = {
  Name: 'Name'
};

exports.Prisma.MarqueeTagsOrderByRelevanceFieldEnum = {
  Name: 'Name',
  Slug: 'Slug'
};

exports.Prisma.NewsletterEmailOrderByRelevanceFieldEnum = {
  Email: 'Email'
};

exports.Prisma.NotificationOrderByRelevanceFieldEnum = {
  ViewerUN: 'ViewerUN',
  ViewerDN: 'ViewerDN',
  ViewerAvatar: 'ViewerAvatar',
  VideoTitle: 'VideoTitle'
};

exports.Prisma.OrdersOrderByRelevanceFieldEnum = {
  OrderCode: 'OrderCode',
  CognitoUserID: 'CognitoUserID',
  IPAddress: 'IPAddress',
  TransID: 'TransID'
};

exports.Prisma.ReferFriendOrderByRelevanceFieldEnum = {
  ReceiverCognitoID: 'ReceiverCognitoID',
  ReceiverUN: 'ReceiverUN',
  ReceiverEmail: 'ReceiverEmail',
  RegisterCognitoID: 'RegisterCognitoID',
  RegisterUN: 'RegisterUN',
  RegisterEmail: 'RegisterEmail'
};

exports.Prisma.ReportBugsOrderByRelevanceFieldEnum = {
  Email: 'Email',
  Title: 'Title',
  Content: 'Content'
};

exports.Prisma.TagsOrderByRelevanceFieldEnum = {
  Name: 'Name',
  Slug: 'Slug',
  Description: 'Description'
};

exports.Prisma.UserBundlePointOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.UserPaymentOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID',
  CustomerProfileId: 'CustomerProfileId',
  PaymentProfileId: 'PaymentProfileId',
  CardHolder: 'CardHolder',
  CardNumber: 'CardNumber',
  CardExpDate: 'CardExpDate',
  CardType: 'CardType',
  FirstName: 'FirstName',
  LastName: 'LastName',
  Email: 'Email',
  Address: 'Address',
  City: 'City',
  Country: 'Country',
  State: 'State',
  Zip: 'Zip',
  Phone: 'Phone',
  DeclineCode: 'DeclineCode'
};

exports.Prisma.UserRentOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.UserSocialPostsOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID',
  Title: 'Title',
  Comment: 'Comment',
  File: 'File'
};

exports.Prisma.UserSubscriptionOrderByRelevanceFieldEnum = {
  SubscriptionID: 'SubscriptionID',
  Name: 'Name',
  IntervalUnit: 'IntervalUnit',
  GifteeCognitoUserID: 'GifteeCognitoUserID',
  GifterName: 'GifterName',
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.UserSubscriptionPointOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.UsersOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID',
  CognitoUserName: 'CognitoUserName',
  CustomerProfileId: 'CustomerProfileId',
  Email: 'Email',
  UserName: 'UserName',
  WordpressPassword: 'WordpressPassword',
  PasswordHash: 'PasswordHash',
  PasswordResetToken: 'PasswordResetToken',
  DisplayName: 'DisplayName',
  ReferralCode: 'ReferralCode',
  Pronouns: 'Pronouns',
  SocialLink: 'SocialLink',
  CaptivatedBy: 'CaptivatedBy',
  NeedToLive: 'NeedToLive',
  GratefulFor: 'GratefulFor',
  Avatar: 'Avatar',
  VerifyLink: 'VerifyLink',
  SendgridRecipientID: 'SendgridRecipientID',
  RedirectToAfterActivation: 'RedirectToAfterActivation'
};

exports.Prisma.NotificationsOrderByRelevanceFieldEnum = {
  Title: 'Title',
  Description: 'Description',
  ActionLink: 'ActionLink',
  ActionText: 'ActionText'
};

exports.Prisma.UsersInvalidOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID',
  Email: 'Email',
  UserName: 'UserName'
};

exports.Prisma.VideoBookmarkOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.VideoCommentOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID',
  Content: 'Content'
};

exports.Prisma.VideoLikeOrderByRelevanceFieldEnum = {
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.VideoParticipantsOrderByRelevanceFieldEnum = {
  FirstName: 'FirstName',
  LastName: 'LastName',
  NickName: 'NickName',
  Email: 'Email',
  Country: 'Country',
  IDImageOne: 'IDImageOne',
  IDImageTwo: 'IDImageTwo',
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.MetaTagsOrderByRelevanceFieldEnum = {
  Name: 'Name',
  Slug: 'Slug',
  Description: 'Description'
};

exports.Prisma.VideosOrderByRelevanceFieldEnum = {
  FirstName: 'FirstName',
  LastName: 'LastName',
  NickName: 'NickName',
  Country: 'Country',
  IDImageOne: 'IDImageOne',
  IDImageTwo: 'IDImageTwo',
  Participants: 'Participants',
  VideoTitle: 'VideoTitle',
  Slug: 'Slug',
  Slug0: 'Slug0',
  VideoDescription: 'VideoDescription',
  Content: 'Content',
  VideoTags: 'VideoTags',
  VideoIntro: 'VideoIntro',
  VideoIntroCaptions: 'VideoIntroCaptions',
  VideoReal: 'VideoReal',
  VideoRealCaptions: 'VideoRealCaptions',
  LandingVideo: 'LandingVideo',
  LandingVideoType: 'LandingVideoType',
  Stills: 'Stills',
  BlurredStill: 'BlurredStill',
  CognitoUserID: 'CognitoUserID'
};

exports.Prisma.ContentPagesOrderByRelevanceFieldEnum = {
  PageName: 'PageName',
  Content: 'Content',
  HtmlContent: 'HtmlContent'
};

exports.Prisma.RecaptchasOrderByRelevanceFieldEnum = {
  Hostname: 'Hostname',
  Action: 'Action'
};

exports.Prisma.UserEventsOrderByRelevanceFieldEnum = {
  Name: 'Name'
};

exports.Prisma.UserEmailsOrderByRelevanceFieldEnum = {
  Type: 'Type',
  Error: 'Error'
};

exports.Prisma.SearchesOrderByRelevanceFieldEnum = {
  Term: 'Term'
};

exports.Prisma.VideoViewSourcesOrderByRelevanceFieldEnum = {
  Source: 'Source'
};

exports.Prisma.CohortSummaryOrderByRelevanceFieldEnum = {
  Type: 'Type',
  Timeframe: 'Timeframe'
};

exports.Prisma.RentalSummaryOrderByRelevanceFieldEnum = {
  Type: 'Type',
  Range: 'Range'
};

exports.Prisma.UserAttributeTagTypeOrderByRelevanceFieldEnum = {
  Name: 'Name',
  Description: 'Description'
};

exports.Prisma.VideoPlaybacksOrderByRelevanceFieldEnum = {
  VideoType: 'VideoType',
  UserType: 'UserType',
  EventType: 'EventType',
  Version: 'Version'
};

exports.Prisma.ForumThreadsOrderByRelevanceFieldEnum = {
  Title: 'Title',
  Content: 'Content'
};
exports.TagOrigin = exports.$Enums.TagOrigin = {
  SYSTEM: 'SYSTEM',
  ADMIN: 'ADMIN',
  USER: 'USER'
};

exports.Prisma.ModelName = {
  Promotions: 'Promotions',
  Packages: 'Packages',
  Purchases: 'Purchases',
  Transactions: 'Transactions',
  Credits: 'Credits',
  Rentals: 'Rentals',
  AuditLogs: 'AuditLogs',
  AuthorizeEventLogs: 'AuthorizeEventLogs',
  Jobs: 'Jobs',
  VideoBundle: 'VideoBundle',
  VideoBundleVideos: 'VideoBundleVideos',
  Bundle: 'Bundle',
  Category: 'Category',
  CuratedCollection: 'CuratedCollection',
  UserTagPreferences: 'UserTagPreferences',
  LandingVideo: 'LandingVideo',
  MarqueeGroupTag: 'MarqueeGroupTag',
  MarqueeGroups: 'MarqueeGroups',
  MarqueeTags: 'MarqueeTags',
  NewsletterEmail: 'NewsletterEmail',
  Notification: 'Notification',
  UserRecentlyViewedVideos: 'UserRecentlyViewedVideos',
  Orders: 'Orders',
  ReferFriend: 'ReferFriend',
  ReportBugs: 'ReportBugs',
  Tags: 'Tags',
  UserBundlePoint: 'UserBundlePoint',
  UserPayment: 'UserPayment',
  UserRent: 'UserRent',
  UserSocialPosts: 'UserSocialPosts',
  UserSubscription: 'UserSubscription',
  UserSubscriptionPoint: 'UserSubscriptionPoint',
  Users: 'Users',
  Notifications: 'Notifications',
  UsersInvalid: 'UsersInvalid',
  UsersStars: 'UsersStars',
  VideoBookmark: 'VideoBookmark',
  VideoCategory: 'VideoCategory',
  VideoComment: 'VideoComment',
  VideoCurated: 'VideoCurated',
  VideoLike: 'VideoLike',
  VideoMarqueeTags: 'VideoMarqueeTags',
  VideoParticipants: 'VideoParticipants',
  VideoTags: 'VideoTags',
  MetaTags: 'MetaTags',
  VideoMetaTags: 'VideoMetaTags',
  Videos: 'Videos',
  ContentPages: 'ContentPages',
  Recaptchas: 'Recaptchas',
  VideoClean: 'VideoClean',
  AuthorizeEventProcessed: 'AuthorizeEventProcessed',
  UserEvents: 'UserEvents',
  UserEventProcessed: 'UserEventProcessed',
  UserEmails: 'UserEmails',
  Searches: 'Searches',
  VideoViewSources: 'VideoViewSources',
  CohortSummary: 'CohortSummary',
  RentalSummary: 'RentalSummary',
  UserAttributeTagType: 'UserAttributeTagType',
  UserAttributeTags: 'UserAttributeTags',
  VideoPlaybacks: 'VideoPlaybacks',
  ForumThreads: 'ForumThreads'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
